"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HoveredButtonWrapperStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
const HoveredButtonWrapperStyled = (0, _styled.default)("div")`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: ${_spacing.sizes.xxSmall}px;
    background-color: rgba(0, 0, 0, 0.15);

    ${_ref => {
  let {
    visible
  } = _ref;
  return visible ? "" : "display: none;";
}}
`;
exports.HoveredButtonWrapperStyled = HoveredButtonWrapperStyled;
//# sourceMappingURL=HoveredButtonWrapperStyled.js.map